import { useQuery } from '@tanstack/react-query'

import { useAccountAppContext } from '@/app/AccountAppContext'

export const useSecurityData = () => {
    const { api, accountKey, bootstrap } = useAccountAppContext()

    const securityEnabled = Boolean(bootstrap?.enabled && bootstrap.authenticated)

    return useQuery({
        queryKey: ['account', accountKey, 'security'],
        queryFn: api.getSecurity,
        enabled: securityEnabled,
        retry: false,
    })
}
